import { IsBoolean, IsEmail, IsNotEmpty, IsObject, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../../../../@base/base.dto';
import { IsMongoIdObject } from '../../../../decorators/is-mongo-object-id.decorator';
import { BetaRegistrationId } from '../../../../types';

export class BetaRegistrationPopulateDto {
  @IsMongoIdObject()
  @IsNotEmpty()
  _id!: BetaRegistrationId;

  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  lastName!: string;

  @IsEmail()
  @IsOptional()
  email?: string;
}

export class CreateBetaRegistrationDto {
  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  lastName!: string;

  @IsEmail()
  @IsNotEmpty()
  email!: string;

  @IsOptional()
  @IsString()
  mobileNumber?: string;

  @IsOptional()
  @IsString()
  role?: string;

  @IsOptional()
  @IsObject()
  metadata?: Record<string, unknown>;
}

export class VerifyBetaRegistrationTokenDto {
  @IsString()
  @IsNotEmpty()
  tokenVaultId!: string;

  @IsString()
  @IsNotEmpty()
  token!: string;
}

export class BetaRegistrationDto extends BaseDto<BetaRegistrationId> {
  @IsOptional()
  @IsString()
  id?: string;

  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  lastName!: string;

  @IsEmail()
  @IsNotEmpty()
  email!: string;

  @IsOptional()
  @IsString()
  mobileNumber?: string;

  @IsOptional()
  @IsString()
  role?: string;

  @IsOptional()
  @IsObject()
  metadata?: Record<string, unknown>;

  @IsBoolean()
  emailVerified!: boolean;

  @IsOptional()
  @IsString()
  tokenVaultId?: string;
}

export const BetaRegistrationFilterKey = {
  EmailVerified: 'emailVerified',
  Role: 'metadata.role',
} as const;

export type BetaRegistrationFilterKey =
  (typeof BetaRegistrationFilterKey)[keyof typeof BetaRegistrationFilterKey];

export const BETA_REGISTRATION_FILTER_KEYS = [
  BetaRegistrationFilterKey.EmailVerified,
  BetaRegistrationFilterKey.Role,
] as const;
